<ibis-file *ngIf="!edit.model.hideCommercial" [entityId]="edit.model.id" [allowUpload]="false" [height]="300"
    [fileMaxSizeMB]="100"></ibis-file>

<dx-data-grid *ngIf="edit.model.hideCommercial" [dataSource]="edit.files" [columnAutoWidth]="true" [height]="300">
    <dxi-column type="buttons" fixedPosition="left" width="110" [allowResizing]="false" [showInColumnChooser]="false">
        <dxi-button [hint]="L('PREVIEW')" icon="file" [onClick]="onPreviewClick"></dxi-button>
        <dxi-button [hint]="L('DOWNLOAD')" icon="download" [onClick]="onDownloadClick"></dxi-button>
    </dxi-column>
    <dxi-column [caption]="L('FILE')" dataField="fi_name" dataType="string"></dxi-column>
    <dxi-column [caption]="L('SIZE')" dataField="fi_size" dataType="number" width="170"
        [calculateDisplayValue]="iui.readableBytes" calculateSortValue="fi_size"></dxi-column>
    <dxi-column [caption]="L('DATE')" dataField="fm_maxDate" dataType="datetime" width="170"
        calculateSortValue="fm_maxDate" [calculateDisplayValue]="iui.formatDateTime"></dxi-column>
    <dxi-column [caption]="L('USERNAME')" dataField="fi_userName" dataType="string"></dxi-column>
</dx-data-grid>
